(() => {
  const root = document.querySelector('#main-product');
  if (!root) return;
  const allowed = new Set(['printing', 'finish', 'numbering', 'card style']);
  const descriptions = JSON.parse(root.querySelector('#vp-card-option-labels')?.textContent || '{}');
  function enhance() {
    root.querySelectorAll('.swatch-single').forEach(group => {
      const name = group.querySelector('.swatch-option-name')?.textContent.trim().toLowerCase();
      if (!allowed.has(name)) return;
      if (name === 'card style' && !root.querySelector('#vp-card-option-labels')) return;
      group.classList.add('vp-production-app');
      if (name === 'card style') group.classList.add('vp-card-style-app');
      group.querySelectorAll('.swatch-view-item').forEach(item => {
        const value = item.getAttribute('orig-value');
        const content = item.querySelector('.swatch-title-and-icon-container');
        const text = content?.querySelector('.swatch-button-title-text');
        if (!value || !content || !text || content.querySelector('.vp-production-icon')) return;
        const input = Array.from(root.querySelectorAll('input[type="radio"]')).find(e => e.value === value && e.name.toLowerCase().includes('-' + name + ']'));
        const icon = input && root.querySelector('label[for="' + CSS.escape(input.id) + '"] .vp-production-icon');
        if (!icon) return;
        content.prepend(icon.cloneNode(true));
        const lines = value.split(' / ');
        const primary = document.createElement('span');
        primary.textContent = lines[0];
        text.replaceChildren(primary);
        if (lines.length > 1) {
          const secondary = document.createElement('small');
          secondary.textContent = lines.slice(1).join(' / ');
          text.append(secondary);
        }
        if (name === 'card style' && descriptions[value]) {
          const detail = document.createElement('small');
          detail.textContent = descriptions[value];
          text.append(detail);
        }
        if (name === 'finish') {
          const sample = content.querySelector('.vp-finish-sample');
          const selectedStyle = root.querySelector('.vp-card-style-app [role="radio"][aria-checked="true"]')?.getAttribute('orig-value');
          if (sample && selectedStyle === 'Painted Edge') sample.classList.add('vp-finish-sample--painted');
        }
        text.classList.add('vp-production-label');
        content.querySelectorAll('*').forEach(e => e.setAttribute('swatch-inside', 'true'));
      });
    });
    const styleGroup = root.querySelector('.vp-card-style-app');
    if (styleGroup) {
      const style = styleGroup.querySelector('[role="radio"][aria-checked="true"]')?.getAttribute('orig-value');
      const finishGroup = Array.from(root.querySelectorAll('.swatch-single')).find(g => g.querySelector('.swatch-option-name')?.textContent.trim().toLowerCase() === 'finish');
      if (finishGroup) {
        const guideText = style === 'Painted Edge' ? descriptions.edgeGuide || '' : style === 'Dual Raised' ? descriptions.dualGuide || '' : '';
        let guide = finishGroup.querySelector('.vp-finish-guide');
        if (guideText && !guide) { guide = document.createElement('p'); guide.className = 'vp-finish-guide'; finishGroup.append(guide); }
        if (guide && guide.textContent !== guideText) guide.textContent = guideText;
        finishGroup.classList.toggle('vp-dual-finish-app', style === 'Dual Raised');
        finishGroup.classList.toggle('vp-painted-finish-app', style === 'Painted Edge');
      }
      const selectedDescription = descriptions[style] || '';
      let styleGuide = styleGroup.querySelector('.vp-style-guide');
      if (!styleGuide) { styleGuide = document.createElement('p'); styleGuide.className = 'vp-style-guide'; styleGroup.append(styleGuide); }
      const descriptionText = (style || '') + ' · ' + selectedDescription;
      if (styleGuide.textContent !== descriptionText) styleGuide.textContent = descriptionText;
      const quantityGroup = Array.from(root.querySelectorAll('.swatch-single')).find(g => g.querySelector('.swatch-option-name')?.textContent.trim().toLowerCase() === 'quantity');
      const quantities = Array.from(quantityGroup?.querySelectorAll('.swatch-view-item') || []).filter(e => getComputedStyle(e).display !== 'none' && e.getAttribute('aria-disabled') !== 'true').map(e => Number((e.getAttribute('orig-value') || '').replaceAll(',', ''))).filter(n => Number.isFinite(n) && n > 0);
      const minimum = root.querySelector('.vp-catalog-pricing__minimum');
      if (minimum && quantities.length) {
        const amount = Math.min(...quantities);
        const label = (descriptions.minimum || '').replace('__VP_QUANTITY__', amount.toLocaleString());
        if (minimum.textContent.trim() !== label) minimum.textContent = label;
      }
    }
  }
  let scheduled = false;
  new MutationObserver(() => {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => { scheduled = false; enhance(); });
  }).observe(root, { childList: true, subtree: true });
  enhance();
})();
